import React, { useState, useEffect, createElement } from 'react'
import Module from 'Layouts/Module'
import { useSelector, useDispatch } from 'react-redux';
import FormHTML from './FormHTML'
import TableData from './TableData'
import Detail from './Detail'
import FormEdit from './FormEdit'
import { scrollToTop, datePost, globalDialog } from '@/Helper'
import { loadCategory, showCategory, deleteCategory, setEdit } from 'Reduxes/inventory/configuration/category/categoryActions'

export default function Category(props) {

    const dev = 0;
    const { data, loading } = useSelector(state => state.categoryReducer)
    const dispatch = useDispatch();
    const dataLength = data.length;
    const setContentActive = activeContent => {
        setContents(
            contents.map(content => {
                content.active = content.name === activeContent
                return content;
            })
        )
    }

    const [contents, setContents] = useState([
        {
            name: 'table',
            active: true,
            component: TableData,
            props: {
                data,
                setContentActiveFormEdit: id => {
                    dispatch(setEdit(id))
                    scrollToTop()
                    setContentActive('formedit')
                },
                setContentActiveDetail: (idShow) => {
                    dispatch(showCategory(idShow))
                    setContentActive('detail')
                },
                deleteCategoryProps: id => {
                    globalDialog(async () => {
                        await dispatch(deleteCategory(id))
                        scrollToTop()
                    })
                }
            },
            title: {
                title: 'Category',
                subtitle: 'Manage data category',
                button: {
                    label: 'Add category',
                    style: 'OrangeMd',
                    icon: 'plus-circle',
                    onClick: () => {
                        setContentActive('form')
                    },
                    subMenu: 'category',
                    type: 'create',
                }
            }
        },
        {
            name: 'form',
            active: false,
            component: FormHTML,
            props: {
                type: 'new',
                goToIndex: () => setContentActive('table'),
            },
            title: {
                title: 'Add new Category',
                subtitle: 'Fill the form below to create new Category',
            },
        },
        {
            name: 'formedit',
            active: false,
            component: FormHTML,
            props: {
                type: 'edit',
                goToIndex: () => setContentActive('table'),
            },
            title: {
                title: 'Update Category',
                subtitle: 'Good to keep the Category data updated',
            }
        }, {
            name: 'detail',
            active: false,
            component: Detail,
            props: {
                setContentActiveFormEdit: idx => {
                    dispatch(showCategory(idx))
                    setContentActive('formedit')
                },
            },
            title: {
                title: 'Category Detail',
                subtitle: '',
                button: {
                    label: 'Go back',
                    style: 'WhiteMd',
                    icon: 'arrow-left',
                    onClick: () => {
                        setContentActive('table')
                    },
                }
            }
        }
    ])

    useEffect(() => {
        dispatch(loadCategory({ allTrue: true }))
    }, [])

    return (
        <>
            {
                contents.map((c, cI) => {
                    if (c.active) {
                        return (
                            <Module {...c.title} key={cI}>
                                {createElement(c.component, c.props)}
                            </Module>
                        )
                    }
                })
            }
        </>
    )
}
